module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recommend-page"
  }, [_c('div', {
    staticClass: "recommend list ",
    staticStyle: {
      "background": "#fff"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box vux-1px-b"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    attrs: {
      "src": _vm.UPLOAD_DOMAIN + _vm.couponProduct.thumbnail + '?x-oss-process=image/resize,w_120'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wz"
  }, [_c('div', [_vm._v(_vm._s(_vm.couponProduct.title)), (_vm.couponProduct.specLabel) ? _c('span', [_vm._v("(" + _vm._s(_vm.couponProduct.specLabel) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "ellipsis"
  }, [_vm._v(_vm._s(_vm.couponProduct.subTitle))]), _vm._v(" "), _c('div', {
    staticClass: "money"
  }, [_vm._v("\n                  ￥ " + _vm._s(_vm._f("fen2yuan")(_vm.couponProduct.price)) + "\n                  "), _c('span', {
    staticClass: "yijiaru"
  }, [_vm._v("已使用兑换券")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "recommend list ",
    staticStyle: {
      "background": "#fff"
    }
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('div', {
      key: product._id,
      staticClass: "box vux-1px-b"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wz"
    }, [_c('div', [_vm._v(_vm._s(product.title)), (product.specLabel) ? _c('span', [_vm._v("(" + _vm._s(product.specLabel) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ellipsis"
    }, [_vm._v(_vm._s(product.subTitle))]), _vm._v(" "), _c('div', {
      staticClass: "money"
    }, [_vm._v("\n                  ￥" + _vm._s(_vm._f("fen2yuan")(product.price)) + "\n                  "), _c('span', {
      staticClass: "yijiaru",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addProduct(product)
        }
      }
    }, [_vm._v("添加 (" + _vm._s(product.quantity || 0) + ")")])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('i', {
    staticClass: "iconfont icon-gouwuche",
    on: {
      "click": function($event) {
        _vm.showPopup = true
      }
    }
  }, [_c('i', {
    staticClass: "tag"
  }, [_vm._v(_vm._s(_vm.selectedProductsLength))])]), _vm._v(" "), _c('div', {
    staticClass: "total"
  }, [_vm._v("\n            合计:￥"), _c('span', {
    staticClass: "money"
  }, [_vm._v(_vm._s(_vm._f("fen2yuan")(_vm.totalPrice)) + "元")])]), _vm._v(" "), _c('div', {
    staticClass: "queren",
    on: {
      "click": _vm.toCreateOrder
    }
  }, [_vm._v("\n            结算\n        ")])]), _vm._v(" "), _c('popup', {
    staticClass: "recommend-popup",
    attrs: {
      "position": "bottom",
      "max-height": "50%"
    },
    model: {
      value: (_vm.showPopup),
      callback: function($$v) {
        _vm.showPopup = $$v
      },
      expression: "showPopup"
    }
  }, [_c('div', {
    staticClass: "recommend list ",
    staticStyle: {
      "background": "#fff"
    }
  }, _vm._l((_vm.selectedProducts), function(product) {
    return _c('div', {
      key: product._id,
      staticClass: "box vux-1px-b"
    }, [_c('div', {
      staticClass: "img"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": ".recommend-popup"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wz"
    }, [_c('div', [_vm._v(_vm._s(product.title)), (product.specLabel) ? _c('span', [_vm._v("(" + _vm._s(product.specLabel) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_vm._v(_vm._s(product.subTitle))]), _vm._v(" "), _c('div', {
      staticClass: "money"
    }, [_vm._v("\n                    ￥" + _vm._s(_vm._f("fen2yuan")(product.price)) + "\n                    "), _c('span', {
      staticClass: "yijiaru"
    }, [_vm._v("x" + _vm._s(product.quantity))])])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "to-order-pay",
    on: {
      "click": _vm.toCreateOrder
    }
  }, [_vm._v("\n          结算\n      ")])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title vux-1px-b recommend-title border-0"
  }, [_c('div', {
    staticClass: "text",
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v("\n              优惠券兑换商品\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title vux-1px-b recommend-title border-0"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n              店铺推荐\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5274beea"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Recommend/Recommend.vue
// module id = 559
// module chunks = 0